import { render, staticRenderFns } from "./add-patient.vue?vue&type=template&id=0b2e85e0&"
import script from "./add-patient.vue?vue&type=script&lang=ts&"
export * from "./add-patient.vue?vue&type=script&lang=ts&"
import style0 from "./add-patient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports